import { render } from "./TemplateList.vue?vue&type=template&id=0f2c348c&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"

import "./TemplateList.vue?vue&type=style&index=0&id=0f2c348c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2c348c"]])

export default __exports__